import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';
import { fetchWithAuth } from '../utils/fetchWithAuth';
const API_URL = process.env.REACT_APP_API_URL || '/api'; // Fallback to localhost during development

const UpdateProfile = () => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  const handleUpdateProfile = async (event) => {
    event.preventDefault();

    try {
      const response = await fetchWithAuth(`${API_URL}/update-profile`, {
        method: 'POST',
        body: JSON.stringify({ username, email })
      });

      const data = await response.json();
      if (data.success) {
        alert('Profile updated successfully!');
        navigate('/home');
      } else {
        alert('Error updating profile: ' + data.message);
      }
    } catch (error) {
      console.error('Error updating profile:', error);
      if (error?.message?.toLowerCase().includes('session expired')) {
        alert('Session expired. Please log in again.');
        navigate('/login?session=expired');
      } else {
        alert('Error updating profile. Please try again later.');
      }
    }
  };

  return (
    <div className="update-profile-container">
      <h2>Update Profile</h2>
      <form onSubmit={handleUpdateProfile}>
        <label htmlFor="username">Username:</label>
        <input
          type="text"
          id="username"
          name="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />

        <label htmlFor="email">Email:</label>
        <input
          type="email"
          id="email"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <button type="submit">Update Profile</button>
      </form>
    </div>
  );
};

export default UpdateProfile;
